import { AbstractControl, ValidationErrors } from "@angular/forms";

export const passwordMatchValidator = (formGroup: AbstractControl): ValidationErrors | null => {
  const password = formGroup.get('password')?.value;
  const confirmPassword = formGroup.get('confirmPassword')?.value;
  return password === confirmPassword ? null : { passwordMismatch: true };
}

export function monthValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!/^(0[1-9]|1[0-2])$/.test(value)) {
    return { invalidMonth: true }; // Custom error key
  }
  return null;
}

export function yearValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!/^\d{4}$/.test(value)) {
    return { invalidYear: true };
  }

  // Convert YY to full year
  const currentYear = new Date().getFullYear();
  const inputYear = parseInt(value);

  if (inputYear < currentYear) {
    return { pastYear: true }; // Year must not be in the past
  }

  return null; // ✅ Valid year
}

export function expirationDateValidator(control: AbstractControl): ValidationErrors | null {
  const currentYear = new Date().getFullYear(); // Get full year (YYYY)
  const currentMonth = new Date().getMonth() + 1; // Get current month (1-12)
  const value = control.value;
  if (!value) return null;

  const [month, year] = value.split('/').map((v: any) => parseInt(v, 10));
  const fullYear = 2000 + year; // Convert YY to YYYY format

  if (!month || !year || month < 1 || month > 12) {
    return { invalidDate: true };
  }

  if (fullYear < currentYear || (fullYear === currentYear && month < currentMonth)) {
    return { pastDate: true };
  }

  return null;
}

export function routingNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value || typeof value !== 'string') {
      return null; // Don't validate empty values here — let `Validators.required` handle that
    }

    if (!/^\d{9}$/.test(value)) {
      return { invalidRoutingFormat: true };
    }

    const weights = [3, 7, 1, 3, 7, 1, 3, 7, 1];
    let sum = 0;

    for (let i = 0; i < 9; i++) {
      sum += parseInt(value.charAt(i)) * weights[i];
    }

    const isValid = sum % 10 === 0;

    return isValid ? null : { invalidRoutingChecksum: true };
}


export function modelSerialMatchValidator(formGroup: AbstractControl): ValidationErrors | null {
  const modelControl = formGroup.get('model');
  const serialNumberControl = formGroup.get('serialNumber');

  if (!modelControl || !serialNumberControl || modelControl.disabled || serialNumberControl.disabled) {
    return null;
  }

  const model = String(modelControl.value ?? '').trim();
  const serialNumber = String(serialNumberControl.value ?? '').trim();

  if (!model || !serialNumber) {
    return null;
  }

  return model.toLowerCase() === serialNumber.toLowerCase() ? { modelSerialSame: true } : null;
}
